export default "__VITE_ASSET__CzdrhX48__"